<template>
  <WrapperFormElements
    :label
    :required
    :hint
    :alertLabel
    :alertType
    :help
  >
    <BasicInputDate
      v-model="modelValue"
      :default-value
      :disabled
      :size
      :validation-state
      :placeholder
      :icon-state
      :icon-name
      :deletable
      :readonly
      :maxlength="10"
      :read-only-reason="props.readOnlyReason"
      hasCalendar
    />
  </WrapperFormElements>
</template>

<script setup lang="ts">
  import type { WrapperInputDateProps, InputDateModel, AlertInputProps } from '@designSystem/components'

  const props = withDefaults(defineProps<WrapperInputDateProps & AlertInputProps>(), {
    hasBg: true,
    wrap: false,
    hasLabel: true,
    maxLength: undefined,
    alertType: undefined,
    alertLabel: undefined,
  })

  const modelValue = defineModel<InputDateModel>()
</script>
